<template>
  <v-container fluid class="pa-0">
    <div v-for="(block, index) in blocks" :key="index">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="block.block_type == 'paragraph'" v-html="getContent(block)" />
      <v-img v-if="block.block_type == 'image'" :src="getImageSrc(block)" />
    </div>
  </v-container>
</template>

<script>
import config from '@/config'

export default {
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getContent(block) {
      const oldUrlRe = new RegExp(config.oldUrl, 'g')

      if (!process.server) {
        const DOMParser = window.DOMParser

        const parser = new DOMParser()

        const htmlDocument = parser.parseFromString(block.content, 'text/html')

        htmlDocument.body
          .querySelectorAll('a')
          .forEach((element) => element.setAttribute('target', '_blank'))

        const htmlString = htmlDocument.body.innerHTML
        return htmlString.replace(oldUrlRe, config.url)
      } else {
        return block.content.replace(oldUrlRe, config.url)
      }
    },
    getImageSrc(block) {
      return block.content.file
    },
  },
}
</script>
